<template>
  <div>
    <v-btn v-if="!isSidebar" small text @click="goBack"
      ><v-icon small color="primary">mdi-keyboard-backspace</v-icon> Back
    </v-btn>
    <v-card v-if="Boolean(school)" class="grey lighten-4" flat>
      <v-list-item>
        <v-list-item-avatar>
          <v-icon x-large> mdi-account-circle </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ school.schoolName }}</v-list-item-title>
          <v-list-item-subtitle>Team: {{ teamName }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card>
    <v-tabs>
      <v-tab>Profile</v-tab>
      <v-tab>Registrations</v-tab>
      <v-tab-item>
        <school-form :schoolId="schoolId"></school-form>
      </v-tab-item>
      <v-tab-item>
        <school-registrations :schoolId="schoolId"></school-registrations>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import SchoolForm from "./school-form";
import SchoolRegistrations from "./school-registrations";
export default {
  props: ["schoolId", "isSidebar"],
  components: {
    SchoolForm,
    SchoolRegistrations,
  },
  data() {
    return {
      school: null,
    };
  },
  mounted() {
    this.school = this.$store.getters["optionsModule/getSchoolById"](
      this.schoolId
    );
  },
  computed: {
    teams() {
      return this.$store.state.optionsModule.teams;
    },
    teamName() {
      var team = this.teams.find((item) => item.teamId === this.school.teamId);
      return Boolean(team) ? team.teamName : "NO TEAM";
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: "SchoolLookup" });
    },
  },
};
</script>
